<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4 white--text">
                  Tax Setting
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Tax Setting"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="1"
              md="3"
              xl="1"
            />
            <v-col
              cols="3"
              md="3"
              xl="3"
              class="mt-2 text-right"
            >
              <tax-dialog-create
                @created="loadData"
              />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          :items="taxes"
          :items-per-page="17"
          multi-sort
          class="scrollable-table elevation-10"
          :search="search"
        >
          <template v-slot:[`item.name`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.percentage`]="{ item }">
            <div>
              <span>
                {{ item.percentage }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.is_valid`]="{ item }">
            <div>
              <v-icon
                v-if="item.is_valid"
                medium
                color="green"
              >
                mdi-check
              </v-icon>
              <v-icon
                v-else
                medium
                color="red"
              >
                mdi-window-close
              </v-icon>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <tax-dialog-edit
              :tax="item"
              @updated="loadData"
            />
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        loading: true,
        search: '',
        taxes: [],

        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Percentage (%)', value: 'percentage', align: 'center' },
          { text: 'Valid', value: 'is_valid', align: 'center' },
          { text: 'Action', value: 'action', align: 'center', class: 'md-2', sortable: false },
        ],
      }
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.taxSettings().list()
          .then(response => {
            this.taxes = response.data
            this.loading = false
          }).catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>

</style>
